export default __webpack_public_path__ + "static/media/logo2.c71c986f.png";